import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

const IsnIntegration = ({ sideContent, children }) => {
  return (
    <div className={styles.body}>
      <div className={`card-body ${styles.sideContent}`}>
        <div>
          <img className={styles.img} src="/isn.png" />
          </div>
        <div>
            {sideContent}
        </div>
      </div>
      {children}
    </div>
  );
}

IsnIntegration.propTypes = {
  sideContent: PropTypes.node,
  children: PropTypes.node
}

export default IsnIntegration;


// WEBPACK FOOTER //
// src/components/shared/IsnIntegration/index.jsx